import { useSearchParams } from 'react-router-dom'
import { regionAt } from '../species/regionFilter'
import { useRegionScope } from '../species/useRegionScope'

/** Район ЦЕНТРА кадра по координатам адреса (их пишет страница на moveend);
 *  `null` — центр вне районов кабинета или карта ещё не двигалась. */
export function useFrameRegion(): string | null {
  const [params] = useSearchParams()
  const { regions } = useRegionScope()
  const lng = params.get('lng')
  const lat = params.get('lat')
  return regionAt(regions, lng ? Number(lng) : null, lat ? Number(lat) : null)
}
